import { connect } from 'react-redux'
import { Minimap } from './Minimap.jsx'
import {
    currentMediaSourceLoaded,
    currentMediaSourceLoading,
} from 'redux/currentMedia/actions'
import {
    initProjectionWithCurrentRotationApplied,
    updateImageReferencePosition,
} from 'redux/canvas/actions'
import { getCurrentMediaProps } from 'redux/mediaList/selectors'
import { isCurrentMediaSourceLoaded } from 'redux/currentMedia/selectors'
import {
    computeMinimapViewData,
    getDefaultScale,
} from 'redux/canvas/selectors'
import {
    getRotation,
    getFilters,
    isInvertActive,
    areFiltersApplied,
} from 'redux/appliedFilters/selectors'
import {
    zoomIn,
    zoomOut,
} from 'redux/appliedFilters/actions'
import { minimapInteraction } from 'redux/minimap/actions'

export const mapStateToProps = (state, props) => ({
    ...getCurrentMediaProps(state),
    isSourceLoaded: isCurrentMediaSourceLoaded(state, props.id),
    computeMinimapViewData: () => computeMinimapViewData(state, props.id, props.parentId),
    rotation: getRotation(state),
    isInvertActive: isInvertActive(state),
    filters: getFilters(state),
    areFiltersApplied: areFiltersApplied(state),
    scaleFactor: getDefaultScale(state, props.id)
})

export const mapDispatchToProps = (dispatch, ownProps) => ({
    sourceLoading: () => dispatch(currentMediaSourceLoading(ownProps.id)),
    sourceLoaded: () => dispatch(currentMediaSourceLoaded(ownProps.id)),
    initProjection: () => dispatch(initProjectionWithCurrentRotationApplied(ownProps.id, ownProps.frame)),
    updateImageReferencePosition: (scaleFactor, vector) => dispatch(updateImageReferencePosition(scaleFactor, vector)),
    zoomIn: () => dispatch(zoomIn()),
    zoomOut: () => dispatch(zoomOut()),
    minimapInteraction: () => dispatch(minimapInteraction()),
})

export const MinimapContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Minimap)
